angular.module('qkr').filter('variantDetailOrder', [function() {
	return function(variantDetailList, orderedLabelList) {
		let correctOrder = true;
	  
		for (let i = 0; i < orderedLabelList.length; i++) {
			const orderedLabel = orderedLabelList[i];
		  
			if (orderedLabel != variantDetailList[i].variantLabel) {
				correctOrder = false;
				break;
			}
		}
	  
		if (correctOrder) {
			return variantDetailList;
		} else {
			// Build up the list in the correct order
			const orderedVariantDetailList = [];
			angular.forEach(orderedLabelList, (orderedLabel) => {
				for (let i = 0; i < variantDetailList.length; i++) {
					const variantDetail = variantDetailList[i];
					if (variantDetail.variantLabel == orderedLabel) {
						orderedVariantDetailList.push(variantDetail);
						break;
					}
				}
			});
			
			return orderedVariantDetailList;
		}
	};
}]);



// WEBPACK FOOTER //
// ./src/filters/variant_detail_order.js